// Meta
export const name = "gvLabel";

// Props
export const schemes = ["primary", "secondary", "tertiary"] as const;
export const aligns = ["start", "center", "end"] as const;
export const sides = ["top", "right", "bottom", "left"] as const;
